/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions";
import "components/elements/main/index.scss";
import {Box, Button, IconButton} from "@mui/material";
import {FlexBetween, FlexBox} from "components/flex-box";
import MockShopHeader from "components/elements/main/MockShopHeader";

import { Avatar, Card, Typography } from "@mui/material";
import { H1, H2, H5, H6 } from "components/CustomTypography";
import {getLogo, openGoogleMapLocation, openInstagram, openWhatsApp} from "helpers/utils";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import * as ActionTypes from "constants/ActionTypes";
import CircularProgress from "@mui/material/CircularProgress";
import PlaceIcon from "@mui/icons-material/Place";
import ButtonComponent from "../../../../Button";
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import UserSellerOtherOfferView from "../../offers/UserSellerOtherOfferView";

const ShopHeaderMiniOverlayOtherShop = (props) => {

    const {
        serviceError, reqStatus,
        history, shopdetail,
    } = props;

  const [state] = useState({
    layoutColumns: 3,
  });

    const openGoogleMap = () => {
        openGoogleMapLocation(shopdetail.location);
    };

    return (
        <Box mb={2}
        >

            <Box
                sx={{
                    display: "flex",
                    p: "4px 4px",
                    height: "100%",
                    alignItems: "center",
                    bgcolor: "#f4f4f4"
                }}
            >
                    <>
                                <Box width="75%" >
                                    <Box width="100%" alignItems="left">
                                        <H2 textTransform="capitalize" fontSize="24px" fontWeight="bold" color="primary.black" ellipsis>
                                            {shopdetail.shopname}
                                        </H2>
                                        <H6 fontSize="12px" color="grey.900">
                                            {shopdetail.area && (shopdetail.area)}
                                        </H6>
                                    </Box>
                                    <FlexBox width="100%" alignItems="left">
                                        <FlexBox width="40%">
                                            <IconButton onClick={() => openGoogleMap()}>
                                                <PlaceIcon fontSize={"medium"} color="primary" />
                                            </IconButton>
                                        </FlexBox>
                                        <Box width="30%" alignItems="left">
                                        </Box>
                                        <Box width="30%" alignItems="left">
                                        </Box>
                                    </FlexBox>
                                </Box>
                            </>
            </Box>
        </Box>
    );
};

export default ShopHeaderMiniOverlayOtherShop;
